export default {
    current: [],
    onlineUsers: []
}
